import React, { useState, useEffect } from "react";
import classes from './Payment.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import svg from "../../Assets/SVG.jpg";
import { Eye, Printer, Trash } from "lucide-react";
import Swal from 'sweetalert2';

import filter from "../../Assets/SVG (1).png";
import exports from "../../Assets/file-export.png";
import invoice from "../../Assets/invoice-04.png";
import vector from "../../Assets/Vector.svg";
import date from "../../Assets/SVG (2).png";
import exported from "../../Assets/SVG (4).png";
import Footer from "../../Components/Footer/Footer";
import CashReciept from "./CashReciept/CashReciept";
import api, { withCompanyId } from "../../Components/API/Api";
// use central `api` so interceptor attaches company_id/store_id

const BankPaymentsrcpt = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [payments, setPayments] = useState([]);
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openCashReciept, setOpenCashReciept] = useState(false);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);

    const [baseCurrencyCode, setBaseCurrencyCode] = useState("NGN");

    useEffect(() => {
        const getBaseCurrencyCode = async () => {
            try {
                const companyRes = await api.get("/v1/companies/get-info");
                const companyData = Array.isArray(companyRes?.data?.data)
                    ? companyRes.data.data[0]
                    : companyRes?.data?.data;

                const currencyId = companyData?.currency_base; 

             
                const currenciesRes = await api.get(`/v1/fetch-all-currencies`);

                if (currenciesRes.data?.data && Array.isArray(currenciesRes.data.data)) {
                  
                    const baseCurrency = currenciesRes.data.data.find(
                        currency => String(currency.id) === String(currencyId)
                    );

                    if (baseCurrency && baseCurrency.code) {
                        setBaseCurrencyCode(baseCurrency.code);
                    } else {
                        setBaseCurrencyCode("NGN"); 
                    }
                }

            } catch (err) {
                console.error("Failed to fetch base currency", err);
                setBaseCurrencyCode("NGN"); // Fallback
            }
        };

        getBaseCurrencyCode();
    }, []);
    const fetchPayments = async (page = null) => {
        const pageToFetch = page || currentPage;
        try {
            setLoading(true);
            const response = await api.get(`/v1/fetch-payments?page=${pageToFetch}`);

            const paginationData = response.data.data;
            const result = Array.isArray(paginationData?.data)
                ? paginationData.data
                : [];

            console.log("Fetched payments page:", pageToFetch, "Last page:", paginationData?.last_page);
            setPayments(result);
            setLastPage(paginationData?.last_page || 1);
            setPerPage(paginationData?.per_page || 100);
            setTotalRecords(paginationData?.total || 0);
        } catch (error) {
            console.error("Error fetching payments:", error);
            setPayments([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPayments(currentPage);
    }, [currentPage]);

    const handlePaymentSuccess = async () => {
        // Reset to first page and refresh
        setCurrentPage(1);
        // ensure fetch first page immediately
        await fetchPayments(1);
    };

    const handleReversePayment = async (payment) => {
        // Confirm before reversing
        const result = await Swal.fire({
            icon: 'warning',
            title: 'Reverse Payment',
            html: `Are you sure you want to reverse this payment?<br><br><strong>Reference:</strong> ${payment.invoice_number || payment.receipt_number || "N/A"}<br><strong>Amount:</strong> ${payment.amount}`,
            showCancelButton: true,
            confirmButtonColor: '#16A34A',
            cancelButtonColor: '#dc2626',
            confirmButtonText: 'Yes, Reverse',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) return;

        try {
            setLoading(true);
            const response = await api.post("/v1/reverse-payments", withCompanyId({
                uuid: payment.uuid,
            }));

            if (response.data?.success === true || response.data?.status === true || (
                response.status >= 200 && response.status < 300 &&
                response.data?.success !== false && response.data?.status !== false
            )) {
                setPayments(currentPayments => currentPayments.filter(item => item.uuid !== payment.uuid));
                setTotalRecords(total => Math.max(total - 1, 0));
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Payment reversed successfully',
                    confirmButtonColor: '#16A34A'
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data?.message || "Failed to reverse payment",
                    confirmButtonColor: '#16A34A'
                });
            }
        } catch (error) {
            console.error("Error reversing payment:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || "Error reversing payment. Please try again.",
                confirmButtonColor: '#16A34A'
            });
        } finally {
            setLoading(false);
        }
    };

    // Pagination controls
    const handleFirstPage = () => setCurrentPage(1);
    const handleLastPage = () => setCurrentPage(lastPage);
    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, lastPage));
    const handlePageChange = (page) => {
        if (page >= 1 && page <= lastPage) {
            setCurrentPage(page);
        }
    };

    const allSelected = selectedRows.length === payments.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(payments.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const getPaymentTo = (row) => {
        if (row.particular) return row.particular;
        if (row.customer) return row.customer.name;
        if (row.supplier) return row.supplier.name;
        return "-";
    };

    // NEW: navigate to the payment receipt route and pass payment via router state
    const handleOpenReceipt = (payment) => {
        // pass the entire payment object; the PaymentReceipt component can read it from location.state.payment
        navigate('/payment-voucher', { state: { payment } });
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Payments</h2>
                    <h1 className={classes.Titles}>
                        View all accounting transactions and account balances in chronological order.
                    </h1>
                </header>

                {/* === Metrics Cards === */}
                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total debits</p>
                                <p className={classes.kdptg1}>
                                    {selectMetrics?.total_debits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Credits</p>
                                <p className={classes.kdptg2}>
                                    {selectMetrics?.total_credits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Trial balance</p>
                                <p className={classes.kdptg3}>
                                    {selectMetrics?.trial_balance?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Balanced</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Entries</p>
                                <p className={classes.kdptg4}>
                                    {selectMetrics?.total_entries?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* === Header Actions === */}
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="svg" className={classes.searchIcon} />
                            <input type="text" className={classes.searchBar} placeholder="Search ledger..." />
                        </div>

                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All accounts</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={date} alt="date" className={classes.dateicon} />
                            <input type="text" className={classes.thirdBar} placeholder="Date Range" />
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={filter} alt="Filter" className={classes.filterIcon} />
                            <input type="text" className={classes.secondBar} placeholder="Filter" />
                        </div>
                    </div>

                    <div className={classes.inputWrapper}>
                        <button className={classes.btnss} onClick={() => setOpenCashReciept(true)}>
                            <img src={exported} alt="added" className={classes.invoiceIcon} />
                            New Payment
                        </button>
                    </div>
                </div>

                {/* === Payments Table === */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>S/N</th>
                                <th>Date</th>
                                <th>Reference</th>
                                <th>Payment To</th>
                                <th>Description</th>
                                <th>Currency</th>
                                <th>Amount</th>
                                <th>{baseCurrencyCode} Amount</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                // ✅ Skeleton loader — 9 rows, 9 columns
                                Array.from({ length: 9 }).map((_, rowIndex) => (
                                    <tr key={`skeleton-${rowIndex}`}>
                                        {[...Array(9)].map((_, colIndex) => (
                                            <td key={colIndex}>
                                                <div className={classes.skeletonBox}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : Array.isArray(payments) && payments.length > 0 ? (
                                payments.map((payment, index) => (
                                    <tr key={payment.id || index}>
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                                        <td>{payment.transaction_date}</td>
                                        <td>{payment.invoice_number || "—"}</td>

                                        <td>{payment.particular || payment.supplier?.name || "—"}</td>
                                        <td>{payment.description || "—"}</td>
                                        <td>{payment.currency?.currency || "—"}</td>
                                        <td style = {{textAlign:"right"}}>
                                            {parseFloat(payment.currency_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        <td style = {{textAlign:"right"}}>
                                            {parseFloat(payment.amount_paid || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                             <span
                                                onClick={() => handleOpenReceipt(payment)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleOpenReceipt(payment); }}
                                                aria-label={`Open receipt ${payment.invoice_number || payment.receipt_number || payment.uuid}`}
                                            ><Eye size={16} style={{ margin: "0 8px", color: "rgb(22,163,74)", cursor: "pointer" }} />
                                            </span>
                                            {/* make printer clickable to view full receipt */}
                                           
                                                <Printer size={16} style={{ margin: "0 8px", color: "rgb(37, 99, 235)", cursor: "pointer" }}/>
                                           
                                            <span
                                                onClick={() => handleReversePayment(payment)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleReversePayment(payment); }}
                                                aria-label={`Reverse payment ${payment.invoice_number || payment.receipt_number || payment.uuid}`}
                                            >
                                                <Trash size={16} style={{ margin: "0 8px", color: "rgb(239, 68, 68)", cursor: "pointer" }} />
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center" }}>
                                        No payment records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* === Pagination Footer === */}
                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td className={`${classes.frston} ${currentPage === 1 ? classes.disabled : ''}`} onClick={handleFirstPage}>First</td>
                            <td className={`${classes.page} ${currentPage === 1 ? classes.activePage : ''}`} onClick={() => handlePageChange(1)}>1</td>
                            {lastPage > 1 && (
                                <>
                                    {currentPage > 3 && <td className={classes.page}>...</td>}
                                    {Array.from({ length: Math.min(3, lastPage - 1) }, (_, i) => {
                                        const pageNum = i + 2;
                                        if (pageNum <= lastPage) {
                                            return (
                                                <td
                                                    key={pageNum}
                                                    className={`${classes.page} ${currentPage === pageNum ? classes.activePage : ''}`}
                                                    onClick={() => handlePageChange(pageNum)}
                                                >
                                                    {pageNum}
                                                </td>
                                            );
                                        }
                                        return null;
                                    })}
                                    {currentPage < lastPage - 2 && lastPage > 4 && <td className={classes.page}>...</td>}
                                    {lastPage > 1 && (
                                        <td
                                            className={`${classes.page} ${currentPage === lastPage ? classes.activePage : ''}`}
                                            onClick={() => handlePageChange(lastPage)}
                                        >
                                            {lastPage}
                                        </td>
                                    )}
                                </>
                            )}
                            <td className={`${classes.lastno} ${currentPage === lastPage ? classes.disabled : ''}`} onClick={handleLastPage}>Last</td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.lasone}>
                    <div className={classes.paginationDisplay}>
                        Displaying {(currentPage - 1) * perPage + 1} - {Math.min(currentPage * perPage, totalRecords)} of {totalRecords}
                    </div>
                </div>
            </div>

            <CashReciept
                isOpen={openCashReciept}
                onClose={() => setOpenCashReciept(false)}
                onSuccess={handlePaymentSuccess}
            />
            <Footer />
        </div>
    );
};

export default BankPaymentsrcpt;